// app messages
export const EMBED_DIMENSIONS_UPDATE = 'embed-height-update';
export const EMBED_INLINE_INSTALL_START = 'embed-inline-install-start';
export const EMBED_PLAY_VIDEO_AT_TS = 'embed-play-video-at-timestamp';
export const EMBED_UPDATE_TIME = 'embed-update-time';
export const EMBED_VIDEO_REFRESH_VIDEO = 'embed-video-refresh-video';
export const EMBED_VIDEO_DURATION = 'embed-video-duration';
export const EMBED_VIDEO_ENDED = 'embed-video-ended';
export const EMBED_VIDEO_CORRECT_PASS = 'embed-video-correct-password-entered';
export const EMBED_VIDEO_PLAY_PAUSE = 'embed-video-space-pressed';
export const EMBED_VIDEO_JUMP_BACK = 'embed-video-j-pressed';
export const EMBED_VIDEO_JUMP_FORWARD = 'embed-video-l-pressed';
export const EMBED_VIDEO_MUTE = 'embed-video-mute';
export const EMBED_VIDEO_STEP_BACK = 'embed-video-comma-pressed';
export const EMBED_VIDEO_STEP_FORWARD = 'embed-video-period-pressed';
export const EMBED_VIDEO_TOGGLE_FULLSCREEN = 'embed-video-toggle-fullscreen';
export const EMBED_VIDEO_TOGGLE_SPEED = 'embed-video-toggle-speed';
export const EMBED_VIDEO_TOGGLE_THEATER = 'embed-video-toggle-theater';
export const EMBED_VIDEO_VOLUME_UP = 'embed-video-volume-up';
export const EMBED_VIDEO_VOLUME_DOWN = 'embed-video-volume-down';
export const EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED =
  'embed-video-processing-information-updated';
export const LO_OAUTH = 'lo-oauth';
export const SHARE_VIDEO_EL_LOADED = 'share-video-el-loaded';
export const SHARE_VIDEO_FLIP_CAMERA = 'share-video-flip-camera';
export const TRIM_ACTION_DISPATCHED = 'trim-action-dispatched';
export const CREATE_EMOJI_REACTION = 'create-emoji-reaction';

// extension <-> app messages
export const EXTENSION_CLICKED = 'extension-clicked';
export const UPDATE_INTEGRATION_SETTINGS = 'update-integration-settings';
export const USER_LOGIN = 'user-login';
export const INITIATE_LOOM_RECORDER_FROM_SCRIPT =
  'initiate-loom-recorder-from-script';
